import { PagingState } from "../../common/interfaces/pagingParam.interface"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { PromotionPackInterface } from "../../common/interfaces/promotionPack.interface"
import { SearchConditionState } from "../../common/interfaces/searchConditionParam"
import { FilterTableEnum } from "../../common/enum/filterTable.enum"
import { SortColumnEnum } from "../../common/enum/sortColumn.enum"
import { SortConditionInterface } from "../../common/interfaces/sortCondition.interface"
import { SortOrderEnum } from "../../common/enum/sortOrder.enum"
import { handleSortOrder } from "../../common/helper/sortTable.helper"

export interface PromotionPackState {
   requesting: boolean
   successful: boolean
   error: string
   data: PromotionPackInterface[]
   rowCount: number
   paging: PagingState
   searchCondition: SearchConditionState
   sortCondition: SortConditionInterface
}

const initialState: PromotionPackState = {
   requesting: false,
   successful: false,
   error: "",
   data: [],
   rowCount: 0,
   paging: {
      pageNumber: 1,
      pageSize: 10,
   },
   searchCondition: {
      option: FilterTableEnum.NONE,
      value: "",
   },
   sortCondition: {
      column: SortColumnEnum.NONE,
      order: SortOrderEnum.ASC,
   },
}

export const promotionPackSlice = createSlice({
   name: "promotionPack",
   initialState,
   reducers: {
      requestPromotionPack: (state: PromotionPackState) => {
         state.requesting = true
      },
      getPromotionPackSuccess: (
         state: PromotionPackState,
         action: PayloadAction<any>
      ) => {
         state.requesting = false
         state.successful = true
         state.error = ""
         state.data = action.payload.data.data
         state.rowCount = action.payload.data.rowCount
      },
      getPromotionPackFail: (
         state: PromotionPackState,
         action: PayloadAction<any>
      ) => {
         state.requesting = false
         state.successful = false
         state.error = action.payload
         state.data = []
      },
      changePageNumberSuccess: (
         state: PromotionPackState,
         action: PayloadAction<number>
      ) => {
         state.paging.pageNumber = action.payload
      },
      changePageSizeSuccess: (
         state: PromotionPackState,
         action: PayloadAction<number>
      ) => {
         state.paging.pageNumber = 1
         state.paging.pageSize = action.payload
      },
      changeSearchConditionSuccess: (
         state: PromotionPackState,
         action: PayloadAction<any>
      ) => {
         state.paging.pageNumber = 1
         state.searchCondition.option = action.payload.option
         state.searchCondition.value = action.payload.value
      },
      changeSortConditionSuccess: (
         state: PromotionPackState,
         action: PayloadAction<any>
      ) => {
         state.sortCondition.order = handleSortOrder(
            state.sortCondition.column,
            action.payload.column,
            state.sortCondition.order
         )
         state.sortCondition.column = action.payload.column
      },
   },
})

export const {
   requestPromotionPack,
   getPromotionPackSuccess,
   getPromotionPackFail,
   changePageNumberSuccess,
   changePageSizeSuccess,
   changeSearchConditionSuccess,
   changeSortConditionSuccess,
} = promotionPackSlice.actions

export default promotionPackSlice.reducer
